import UtilsSchema from "@repoflow/schema/utils";

import {
  orgId,
  bucketId,
  description,
  exts,
  size,
  minFileSize,
  maxFileSize,
  createdAt,
  updatedAt
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/Bucket",
    type: "object",
    properties: {
      orgId,
      bucketId,
      description,
      exts,
      size,
      minFileSize,
      maxFileSize,
      createdAt,
      updatedAt
    }
  },
  {
    id: "/Public/Bucket/Create",
    type: "object",
    properties: {
      description,
      exts,
      size,
      minFileSize,
      maxFileSize,
    },
    required: ["description", "size"],
  },
  {
    id: "/Public/Bucket/Update",
    type: "object",
    properties: {
      description,
      exts,
      size,
      minFileSize,
      maxFileSize,
    },
    required: [],
  },
];
